import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';
import { Box, Card, CardContent, Grid, Typography } from '@mui/material';
import { memo } from 'react';
import strings from '../../../Globalization';
import DigitalGraph from '../../../components/common/DigitalGraph';
import consts from '../../../consts';
import { useCycleInfo } from '../../../contexts/CycleInfo/Context';

const Rinse = ({ property = 'RINSE1_2' }) => {
	const { data: cycle } = useCycleInfo();
	let propertyName = property.split('_')[0];
	const data = cycle.ChartDetail[property];
	const isEnspire = cycle.EquipmentFamilyId === consts.EquipmentFamilyType.ENSPIRE;


	return (
		<Grid container>
			<Grid size={12}>
				<Card>
					<CardContent sx={{ padding: 4 }}>
						<Grid container>
							<Grid size={{xs: 12, md: 4}} paddingTop={2}>
								<Box
									display={'flex'}
									sx={{
										borderTop: (theme) => `1px solid ${theme.palette.divider}`,
										borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
										padding: (theme) => theme.spacing(1)
									}}
								>
									<Typography flex={1}>
										{strings[propertyName]}
										{data.ThermalRinseA0 === 'None' ? '' : '- ' + data.ThermalRinseA0}
									</Typography>
									<TimerOutlinedIcon />
								</Box>

								<Box p={1}>
									<Typography
										textAlign={'center'}
										fontWeight={'bold'}
										variant="body2"
										gutterBottom
									>
										{strings.FillingPortPure}{' '}
										{isEnspire && data?.Rinse?.WaterPort === consts.WasterPort.FilteredWater
											? strings.FilteredWater
											: data?.Rinse?.WaterPort}
									</Typography>
									<DigitalGraph title={strings.SetTime} value={data.Rinse.SetTime} />
									<DigitalGraph title={strings.ActualTime} value={data.Rinse.ActualTime} />
								</Box>
							</Grid>
						</Grid>
					</CardContent>
				</Card>
			</Grid>
		</Grid>
	);
};

export default memo(Rinse);
